<template>
  <div class="zero">
   
    <Header />
    <div class="content">
      <img src="../../../assets/coursePage/gra/H5-1.png"/>
      <img src="../../../assets/coursePage/gra/H5-2.png"/>
      <img src="../../../assets/coursePage/gra/H5-3.png"/>
      <div class="block">
         <img src="../../../assets/coursePage/gra/H5-4.png"/>
         <a @click="go1()">去项目库选项目</a>
         <a  class="btn2"  @click="addTeacher()">去找老师咨询定制</a>
      </div>
      <div class="block">
         <img src="../../../assets/coursePage/gra/H5-5.png"/>
         <a class="btn3" @click="goPrize()">去抽奖</a>
      </div>
      
      <img src="../../../assets/coursePage/gra/H5-6.png"/>
      <img src="../../../assets/coursePage/gra/H5-7.png"/>
      <div class="block">
        <img src="../../../assets/coursePage/gra/H5-8.png"/>
        <b @click="go2()">课程列表：在线表格</b>
      </div>
      
    </div>
    <Footer />
    <van-popup v-model="show" position="bottom" round>
      <div class="pop">
        <div class="pop-top">
          <div class="title">{{popContent.title}}</div>

          <div class="close" @click="show = false"></div>
        </div>

        <div class="bottom">
          <img :src="popContent.img"/>
          <p>{{popContent.text}}</p>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>

import Header from "../common/Header.vue";
import Footer from "../common/Footer.vue";
export default {
  components: {
   
    Header,
    Footer,
  
  },
  data() {
    return {
      show:false,
      popContent:{
        img:'',
        title:'',
        text:''

      }
    };
  },
  methods: {
   go2(){
    window.open('https://www.yuque.com/aimohai/frgpgk/iba3xuhgl8w398mf?singleDoc#bOgK')
   },
   go1(){
    window.open('https://m.boxuegu.com/campaign/coursePage.html?subject=design&pageType=0')
   },
   addTeacher(){
     this.popContent={
        img:require('../../../assets/coursePage/gra/code1.png'),
        title:'添加老师',
        text:'详细咨询定制辅导'

      }
    this.show=true
   },
   goPrize(){
    this.show=true
    this.popContent={
        img:require('../../../assets/coursePage/gra/code2.png'),
        title:'添加老师',
        text:'获取抽奖链接'

      }
   },
  },
};
</script>

<style lang="scss" scoped>
.zero{
  .pop {
    padding: 48px 48px 58px 48px;
    min-height: 592px;
    box-sizing: border-box;
    overflow-y: auto;
    box-sizing: border-box;
    .pop-top {
    position: relative;
      .title {
        font-size: 36px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #1d2129;
        line-height: 52px;
        text-align: center;
      }
    }
    .close {
      position: absolute;
      top:0;
      right: 0;
      width: 32px;
      height: 32px;
      background: url("../../../assets/coursePage/ai/box8/close.png") no-repeat;
      background-size: cover;
    }
.bottom{
  margin-top: 64px;
  text-align: center;
  img{
    width: 252px;
  }
  p{
    font-family: PingFangSC, PingFang SC;
font-weight: 400;
font-size: 28px;
color: #1D2129;
line-height: 44px;
text-align: center;
font-style: normal;
margin-top: 16px;
  }
}
 
  }
  .content{
    padding-top: 88px;
    .block{
      position: relative;
      b{
        font-family: SourceHanSansSC, SourceHanSansSC;
        font-weight: bold;
        font-size: 24px;
        color: #282828;
        line-height: 36px;
        text-align: center;
        font-style: normal;
        text-decoration-line: underline;
        position: absolute;
        top:374px;
        left: 50%;
        transform: translateX(-50%);
      }
      a{
        position: absolute;
        top:520px;
        left: 50%;
        transform: translateX(-50%);
        width: 396px;
height: 68px;
background: linear-gradient( 270deg, #AEFF0B 0%, #E3FF3B 100%);
border-radius: 33px;
border: 2px solid #52662B;
font-family: SourceHanSansSC, SourceHanSansSC;
font-weight: 500;
font-size: 32px;
color: #282828;
line-height: 68px;
text-align: center;
font-style: normal;

      }
      .btn2{
         position: absolute;
        top:910px;
        left: 50%; 
        transform: translateX(-50%);
      }
      .btn3{
         position: absolute;
        bottom:66px;
        left: 50%; 
        top: auto;
        transform: translateX(-50%);
      }
    }
    img{
      width: 100%;
      display: block;
    }
  }
}
</style>
